const initialStateModal = {
    isOpen: false,
    children: '',
    header: '',
    onClose: () => {},
};

const initialState = {
    activeModals: initialStateModal,
};

export const miniModalReducer = function (state = initialState, action) {
    switch (action.type) {
        case 'openMiniModal': {
            let data = {...state};
            data.activeModals = {
                isOpen: true,
                options: action.options,
                header: action.header,
                children: action.children,
                onClose: action.onClose,
            };
            return data;
        }
        case 'closeMiniModal': {
            let data = {...state};
            data.activeModals = initialStateModal;
            return data;
        }
        default:
            return state;
    }
};